module.exports = __webpack_public_path__ + "img/189.ca8e3786.jpg";